import { Plus } from "lucide-react";
import { InfoCard } from "@/components/workOrderTab/WOGeneralCard";
import { BillingContactSection } from "./BillingContactSection";
import { ContactsListSection } from "./ContactsListSection";

const Group = ({ title, action, children, testId }) => (
  <div className="space-y-2" data-testid={testId}>
    <div className="flex items-center justify-between">
      <h4 className="text-[11px] font-semibold tracking-wide text-slate-500">{title}</h4>
      {action}
    </div>
    {children}
  </div>
);

// "Directory" card on the customer General tab — Billing contact + site/customer contacts (WO Directory pattern).
export function ClientDirectoryCard({
  selectedClient, formData, setFormData, clientSites, setClientSites, selectedSiteId, primarySite,
  editingBillingContact, setEditingBillingContact, formLoadingRef,
  visibleContacts, editingContactId, setEditingContactId, isAddingContact, setIsAddingContact,
  newContact, setNewContact, contactRoles, updateContact, removeContact, addContact, addContactRole,
}) {
  return (
    <InfoCard title="Directory" testId="client-directory-card" className="h-full">
      <div className="space-y-6">
        <Group title="Billing Contact" testId="billing-contact-section">
          <BillingContactSection
            selectedClient={selectedClient} formData={formData} setFormData={setFormData}
            clientSites={clientSites} setClientSites={setClientSites} selectedSiteId={selectedSiteId}
            editingBillingContact={editingBillingContact} setEditingBillingContact={setEditingBillingContact}
            formLoadingRef={formLoadingRef}
          />
        </Group>
        <Group title={selectedSiteId === "all" ? "Contacts" : "Site Contacts"}
          action={(
            <button type="button" onClick={() => setIsAddingContact(!isAddingContact)} title="Add a contact" data-testid="btn-toggle-add-contact"
              className="inline-flex h-6 w-6 items-center justify-center rounded-md border text-slate-500 hover:text-slate-800 hover:bg-slate-100">
              <Plus className="w-3.5 h-3.5" />
            </button>
          )}>
          <ContactsListSection
            visibleContacts={visibleContacts} formData={formData} selectedSiteId={selectedSiteId} primarySite={primarySite}
            editingContactId={editingContactId} setEditingContactId={setEditingContactId}
            isAddingContact={isAddingContact} setIsAddingContact={setIsAddingContact}
            newContact={newContact} setNewContact={setNewContact} contactRoles={contactRoles}
            updateContact={updateContact} removeContact={removeContact} addContact={addContact} addContactRole={addContactRole}
          />
        </Group>
      </div>
    </InfoCard>
  );
}
